export const distractCategories = [
    { value: 'Inadimplência', label: 'Inadimplência' },
    { value: 'Entrega Imóvel', label: 'Entrega Imóvel' },
    { value: 'Insatisfação', label: 'Insatisfação' },
    { value: 'Geração Própria', label: 'Geração Própria' },
    { value: 'Não Informado', label: 'Não Informado' },
    { value: 'Concorrência', label: 'Concorrência' },
    { value: 'Repasse Imóvel', label: 'Repasse de Imóvel' },
    { value: 'Caso Fortuito', label: 'Caso Fortuito' },
    { value: 'Troca de Titularidade', label: 'Troca de Titularidade' },
    { value: 'Vetado', label: 'Vetado' },
    { value: 'Vetado - Perdas', label: 'Vetado - Perdas' },
    { value: 'Vetado - Parcelamento', label: 'Vetado - Parcelamento' },
    { value: 'Vetado - AT', label: 'Vetado - AT' },
    { value: 'Vetado - Baixa Renda', label: 'Vetado - Baixa Renda' }
];
